import React from 'react'
import classes from './Product.module.css'
import { useState } from 'react';
import CartContext from '../../store/CartContext';
import { useContext } from 'react';

const Product = (props) => {

    const cartContext = useContext(CartContext);

    const onAddToCartHandler = ()=>{
        cartContext.addItem({
            id: props.id,
            image: props.pillImg,
            name: props.title,
            amount: itemCount,
            priceBTC: props.priceBTC,
            priceETH: props.priceETH
        })
    }

    const [itemCount,setItemCount]=useState(1);
    const addOne=() =>{
        setItemCount(itemCount+1);
    }
    const subOne=() =>{
        setItemCount(itemCount-1);
    }


    const pillImg = props.pillImg;
    const image = require('../../UI/img/'+ pillImg +'.png');
    
    var stars = [];
    for (let i = 0; i < props.rating; i++) {
        stars.push(
            <i className="fas fa-star " key={i}></i>);
    }
    for (let i = 0; i < 5 - props.rating; i++) {
        stars.push(
        <i className="far fa-star " key={i}></i>);
        }

    return (
    <div className={classes.product} >
    <div className={classes.prodLeft}>
        <img src={image.default} alt="" />
        <p>RATING</p>
        <br />
        <div className="stars">
            {stars}
        </div>
    </div>

    <div className={classes.prodRight}>
        <h2>{props.title}</h2>
        <br />
        <h3>{props.priceBTC} BTC / {props.priceETH} ETH</h3>
        <br />
        <p>Contains {props.content} of MDMA.</p>
        <br />
        <div className={classes.prodQty}>
            <div className={`${classes.qtyBtn} ${classes[props.color]}`} onClick={subOne}><p>-</p></div>
            <p className={classes.qty}>{itemCount.toString()}</p>
            <div className={`${classes.qtyBtn} ${classes[props.color]}`} onClick={addOne}><p>+</p></div>
        </div>
        <br />
        <a  className={`${classes.addToCart} ${classes[props.color+'G']}`} onClick={onAddToCartHandler} >ADD TO CART</a>
    </div>
    
</div>
    )
}

Product.defaultProps = {
    pillImg: 'bluePill'
  };

export default Product
